<template>
  <div class="nav-account">
    <a id="nav-account-expander" href="#"></a>
    <div class="links guest-links hidden">
      <router-link class="nav-item-router" to="/login">
        <div class="nav-account-item" id="log-in">
          <a href="#">Log In</a>
        </div>
      </router-link>
      <router-link class="nav-item-router" to="/login?signup=true">
        <Button text="Sign Up" id="sign-up" />
      </router-link>
    </div>
    <div class="links user-links" tabindex="0" @click="expandNavAccountMounted">
      <div class="nav-item-router" @click="decideFuctionality">
        <NavItem text="My Profile" id="my-profile" />
        <div class="profile-img">
          <img
            :src="profileImage"
            id="user-profile-image"
            alt="User's Profile Image"
            style="width: 100%"
          />
        </div>
        <div class="red-notice" id="profile-img"></div>
      </div>
      <div class="profile-dropdown" tabindex="0">
        <router-link class="nav-item-router" to="/notifications">
          <div class="red-notice" id="notify"></div>
          <NavItem text="Notifications" icon="bell" />
        </router-link>
        <router-link class="nav-item-router" to="/">
          <NavItem v-on:click="logoutUser" text="Log Out" icon="sign-out-alt" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Button from "./Button.vue";
import NavItem from "./NavItem.vue";

function linkVisibility() {
  let guestLinks = document.querySelector(".links.guest-links");
  let userLinks = document.querySelector(".links.user-links");

  if (localStorage.getItem("jwt") !== null) {
    // KEY EXISTS
    guestLinks.classList.add("hidden");
    userLinks.classList.remove("hidden");
  } else {
    guestLinks.classList.remove("hidden");
    userLinks.classList.add("hidden");
  }
}

function containsKey(obj, key) {
  if (key in obj) {
    return true;
  }
  return false;
}

function expandNavAccount(self) {
  let guestLinks = document.querySelector(".links.guest-links");
  let userLinks = document.querySelector(".links.user-links");

  if (localStorage.getItem("jwt") !== null) {
    // KEY EXISTS
    userLinks.querySelector(".profile-dropdown").style.display = "flex";
    self.expanded = true;
  } else {
    guestLinks.classList.remove("hidden");
    userLinks.classList.add("hidden");
    self.expanded = false;
  }
}

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

function goToPage(route, _self) {
  _self.$router.push(route);
}

function fetchMessages(headers) {
  let notice1 = document.querySelectorAll(".red-notice#notify");
  let notice2 = document.querySelectorAll(".red-notice#profile-img");

  axios
    .get(`${process.env.VUE_APP_BACKEND}/messages`, {
      headers: headers,
    })
    .then(function (res) {
      if (res.data.length > 0) {
        console.clear();
        console.log("Notification Items: ");
        let pendingNotifications = res.data.filter(function (item) {
          return item.status == "Pending";
        }).length;
        if (pendingNotifications > 0) {
          notice1.forEach((element) => {
            element.style.display = "block";
          });

          notice2.forEach((element) => {
            element.style.display = "block";
          });
        } else {
          notice1.forEach((element) => {
            element.remove();
          });

          notice2.forEach((element) => {
            element.remove();
          });
        }
      } else {
        notice1.forEach((element) => {
          element.remove();
        });

        notice2.forEach((element) => {
          element.remove();
        });
      }
    })
    .catch(function () {
      notice1.forEach((element) => {
        element.remove();
      });

      notice2.forEach((element) => {
        element.remove();
      });
    });
}

export default {
  name: "NavBarAccount",
  components: { Button, NavItem },
  methods: {
    logoutUser() {
      let self = this;
      localStorage.removeItem("jwt");
      if (self.$router.currentRoute.value.fullPath == "/") {
        self.$router.go();
      } else {
        self.$router.push("/");
      }
    },
    expandNavAccountMounted() {
      let self = this;
      expandNavAccount(self);
    },
    decideFuctionality() {
      let self = this;
      // console.log(`DEVICE: ${self.device}`);
      // console.log(`EXPANDED: ${self.expanded}`);

      if (self.device == "desktop") {
        goToPage("/profile", self);
      } else {
        if (self.expanded === true) {
          goToPage("/profile", self);
        } else {
          expandNavAccount(self);
        }
      }
    },
  },
  mounted() {
    linkVisibility();
    let self = this;
    let jwt = localStorage.getItem("jwt");
    if (jwt !== null) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // true for mobile device
        this.device = "mobile";
      } else {
        // false for not mobile device
        this.device = "desktop";
      }
      const headers = {
        Authorization: "Bearer " + jwt,
      };
      // console.log(`${process.env.VUE_APP_BACKEND}/users/info`);
      axios
        .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
          headers: headers,
        })
        .then(function (res) {
          if (
            containsKey(res.data, "profileImage") &&
            res.data.profileImage !== "string" &&
            res.data.profileImage !== ""
          ) {
            if (validURL(res.data.profileImage)) {
              self.profileImage = res.data.profileImage;
            } else {
              // GET IMAGE WITH GET REQUEST
              axios
                .get(
                  `${process.env.VUE_APP_BACKEND}/users/images/` +
                    res.data.profileImage,
                  {
                    headers: headers,
                  }
                )
                .then(function () {
                  self.profileImage =
                    `${process.env.VUE_APP_BACKEND}/users/images/` +
                    res.data.profileImage;
                })
                .catch(() => {
                  self.profileImage = "/paw.svg";
                });
            }
          } else {
            self.profileImage = "/paw.svg";
          }
        })
        .catch(() => {
          self.$router.go();
        });

      fetchMessages(headers);
    }
  },
  data() {
    return {
      profileImage: "",
      device: "",
      expanded: false,
    };
  },
};
</script>
<style scoped>
.nav-account {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1rem;
  margin-left: auto;

  /* FOR TESTING */
  overflow: visible;
}

.links {
  overflow: visible;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.hidden {
  display: none;
}

.nav-item {
  flex-direction: row-reverse;
}

@media screen and (max-width: 30rem) {
  .nav-account {
    flex-direction: column;
    width: 100%;
    align-items: flex-end;
    overflow: visible;
  }

  .nav-account-item {
    font-size: 0.8rem;
  }

  #log-in {
    display: none;
  }
}

a {
  text-decoration: none;
  color: var(--dark-clr);
  transition: 0.5s ease;
}

.nav-account-item {
  /* height: 100%; */
  width: max-content;
  padding: 0 1rem 0 1rem;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
}
a:hover,
a:focus {
  color: var(--mid-dark-clr);
}

.nav-item-router {
  /* height: 100%; */
  /* display: flex;
  justify-content: center;
  align-items: center; */
  /* overflow: initial;
  cursor: pointer; */
  display: flex;
  align-items: center;
  overflow: visible;
  position: relative;
  z-index: 10;
}

div.nav-item-router {
  cursor: pointer;
}

.profile-img {
  /* height: 2em !important; */
  width: 2em !important;
  aspect-ratio: 1 !important;
  border-radius: 100%;
  /* box-shadow: 0 0 0.2em var(--dark-clr); */
  cursor: pointer;
  transition: var(--transition);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.profile-img:hover,
.profile-img:focus {
  box-shadow: 0 0 0 0.13em var(--primary-clr);
}

/* .profile-img img { */
/* transform: rotate(180deg); */
/* height: 100%; */
/* aspect-ratio: 1; */
/* } */

.profile-dropdown {
  display: none;
  position: absolute;
  background-color: var(--light-clr);
  right: 0em;
  top: 0em;
  min-width: 160px;
  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  z-index: 1;
  border-radius: var(--border-radius);
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 1em;
  padding-block-start: 3em;
  gap: var(--gap);
}

.links.user-links:hover .profile-dropdown,
.links.user-links:focus .profile-dropdown {
  display: flex;
}

#nav-account-expander:hover ~ .links.user-links .profile-dropdown,
#nav-account-expander:focus-within ~ .links.user-links .profile-dropdown {
  display: flex;
}

.profile-dropdown:hover,
.profile-dropdown:focus {
  display: flex;
}

.red-notice {
  width: 0.5rem;
  aspect-ratio: 1;
  position: absolute;
  background: radial-gradient(at 30% 30%, rgb(255, 69, 69), rgb(177, 0, 0));
  border-radius: 50%;
  left: -0.5em;
  align-self: center;
  /* margin-top: 1em; */
}

#profile-img {
  width: 0.5rem;
  aspect-ratio: 1;
  position: absolute;
  background: radial-gradient(at 30% 30%, rgb(255, 69, 69), rgb(177, 0, 0));
  border-radius: 50%;
  left: calc(100% - 2em);
  z-index: 9000;
  top: calc(50% - 1em);
}
@media screen and (max-width: 58rem) {
  .profile-dropdown {
    top: calc(100% - 3.5em);
  }
}

@media screen and (max-width: 54rem) {
  .profile-dropdown {
    top: calc(100% - 3.5em);
  }
}
</style>
